const permissionGroups = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_ALL_PERMISSION_GROUPS_SUCESS':
      return action.permissionGroups;
    default:
      return state;
  }
};

export default permissionGroups;
